export default "__VITE_ASSET__719b9385__"